module.exports = __webpack_public_path__ + "img/icono_carrito.b5cecb9d.png";